












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Home extends Vue {
  @Prop({type: String, default: ''}) public title
  @Prop({type: String, default: ''}) public text
  @Prop({type: String, default: ''}) public icon
  @Prop({type: String, default: ''}) public link
}
